import { Popover } from '@headlessui/react';
import { Link } from 'react-router';

import type { OrderNotification } from '~/types/order';
import { formatDate, formatRelative } from '~/utils/datetime';

type NotificationContentProps = {
  notification: OrderNotification;
};

export function NotificationContent({ notification }: NotificationContentProps) {
  return (
    <Popover.Button as={Link} to={notification.url} className="block h-fit p-3">
      {notification.content}
      <time
        title={`Created at ${formatDate(notification.createdAt, 'long')}`}
        dateTime={notification.createdAt}
        className="block text-xs leading-tight text-[#1C64F2]"
      >
        {formatRelative(new Date(notification.createdAt), new Date())}
      </time>
    </Popover.Button>
  );
}
